<div class="dashboard-widget">
  <div class="small-widget">
    <label class="small-label">Birthdays</label>
    <div class="big-number">{{count}}</div>
    <div class="details-link"><a href="" (click)="viewDetails(); $event.preventDefault();">view details</a></div>
  </div>
</div>
